












































































































































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { ItemVitrineVirtual, VitrineVirtualModule } from '@/store/vuex/produto/VitrineVirtualStore'
import { hashColor } from '@/shareds/badge-utils'
import type { ConferenciaDoCarrinho, StatusDoItemNoCarrinho } from '@/shareds/conferencia-de-vitrine-virtual'
import Confirmacao from '@/components/ui/Confirmacao.vue'

@Component({
	components: {
		Confirmacao,
	},
})
export default class DialogoDeCarrinhoDaVitrineVirtual extends Vue {
	@Ref() confirmacaoDeLimparCarrinho!: Confirmacao

	@Prop({
		type: Object,
		default: () => ({ emAndamento: false, conferidas: 0, total: 0, statusPorSku: {} }),
	}) conferencia!: ConferenciaDoCarrinho

	mostra = false
	hashColor = hashColor
	imagemPadrao = 'https://i.pinimg.com/originals/61/3c/ea/613ceaae3543acdf381af20da47612dc.png'

	mostrar() {
		this.mostra = true
	}

	fechar() {
		this.mostra = false
	}

	statusDoItem(item: ItemVitrineVirtual): StatusDoItemNoCarrinho | null {
		return this.conferencia.statusPorSku[item.produto.sku] ?? null
	}

	itemComErro(item: ItemVitrineVirtual): boolean {
		const status = this.statusDoItem(item)
		return status === 'sem-estoque' || status === 'falha'
	}

	get quantidadeSemEstoque(): number {
		return this.itensCarrinho.filter(item => this.statusDoItem(item) === 'sem-estoque').length
	}

	get quantidadeComFalha(): number {
		return this.itensCarrinho.filter(item => this.statusDoItem(item) === 'falha').length
	}

	get mensagemDeItensSemEstoque(): string {
		return this.quantidadeSemEstoque === 1
			? '1 item não está mais disponível na vitrine. Remova ou troque o item marcado para continuar.'
			: `${this.quantidadeSemEstoque} itens não estão mais disponíveis na vitrine. Remova ou troque os itens marcados para continuar.`
	}

	get mensagemDeItensComFalha(): string {
		return this.quantidadeComFalha === 1
			? 'Não foi possível conferir a disponibilidade de 1 item. Tente novamente.'
			: `Não foi possível conferir a disponibilidade de ${this.quantidadeComFalha} itens. Tente novamente.`
	}

	get textoDoBotao(): string {
		if (this.conferencia.emAndamento) {
			return `Conferindo estoque... ${this.conferencia.conferidas} de ${this.conferencia.total}`
		}
		if (this.quantidadeComFalha && !this.quantidadeSemEstoque) return 'Conferir de novo'
		return `Adicionar na venda · ${this.valorTotalFormatado}`
	}

	get itensCarrinho(): ItemVitrineVirtual[] {
		return VitrineVirtualModule.dados.produtos || []
	}

	get valorTotal(): number {
		return this.itensCarrinho.reduce((total, item) => {
			return total + ((item.produto.preco || 0) * item.quantidade)
		}, 0)
	}

	get valorTotalFormatado(): string {
		return this.formatarValor(this.valorTotal)
	}

	formatarValor(valor: number): string {
		return new Intl.NumberFormat('pt-BR', {
			style: 'currency',
			currency: 'BRL',
		}).format(valor || 0)
	}

	substituirPelaImagemPadrao(evento: Event) {
		const imagem = evento.target as HTMLImageElement
		if (imagem.src === this.imagemPadrao) return
		imagem.src = this.imagemPadrao
	}

	getImagem(item: ItemVitrineVirtual): string {
		const produto = item.produto

		if (!produto?.urlImagens) return this.imagemPadrao

		if (typeof produto.urlImagens === 'string') {
			return produto.urlImagens
		}

		if (Array.isArray(produto.urlImagens) && produto.urlImagens.length) {
			const padrao = produto.urlImagens.find((img: any) => img.padrao === true)
			const imagem = padrao || produto.urlImagens[0]

			if (typeof imagem === 'string') return imagem
			if (imagem?.imagemUrl) return imagem.imagemUrl
		}

		if ((produto.urlImagens as any)?.imagemUrl) {
			return (produto.urlImagens as any).imagemUrl
		}

		if ((produto.urlImagens as any)?.url) {
			return (produto.urlImagens as any).url
		}

		return this.imagemPadrao
	}

	removerItem(item: ItemVitrineVirtual) {
		const itensAtualizados = this.itensCarrinho.filter((i) => i.produto.id !== item.produto.id)

		VitrineVirtualModule.setDados({
			produtos: itensAtualizados,
		})
	}

	async confirmarLimpar() {
		const confirmou = await this.confirmacaoDeLimparCarrinho.mostrar()
		if (!confirmou) return
		this.limparCarrinho()
	}

	limparCarrinho() {
		VitrineVirtualModule.resetar()
	}

	concluir() {
		if (this.conferencia.emAndamento) return
		this.$emit('finalizar', this.itensCarrinho)
	}
}
